import ClientModule from "@gqlapp/module-client-react";
import { onAppCreate } from "@lib/classes/PageLayout";
import HeaderBlock from "@modules/layout/components/HeaderBlock";
import NavigationBlock from "@modules/layout/components/NavigationBlock";
export default new ClientModule({
	onAppCreate: [onAppCreate],
	blocks: [
		{ position: "web.head", component: HeaderBlock, weight: -1 },
		{ position: "web.top", component: NavigationBlock },
	],
});
